import React from "react";
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'


const HelpButton = (props) => {
    const { t } = props

    return (
        t('guide.launchGuide') && (t('guide.launchGuide.versionNumber') > 0) && (props.selectedHomePage.uniqueKey !== "notifications" && props.selectedHomePage.uniqueKey !== "notification") ?
        <div class="info-help" onClick={props.openLaunchGuide}>
            <a><i class="fas fa-question"></i></a>
        </div> 
        : null
    )
}


const mapStateToProps = state => {
    return {
        selectedHomePage: state.store2.currentHomePage
    }
}

export default connect(mapStateToProps)(withTranslation('translations')(HelpButton));